import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function PlusSquare({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <PlusSquare.Outline {...props} />
  ) : (
    <PlusSquare.Solid {...props} />
  );
}

PlusSquare.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M12 7.57739C12.4142 7.57739 12.75 7.91318 12.75 8.32739V11.2405H15.6666C16.0808 11.2405 16.4166 11.5763 16.4166 11.9905C16.4166 12.4047 16.0808 12.7405 15.6666 12.7405H12.75V15.6537C12.75 16.068 12.4142 16.4037 12 16.4037C11.5858 16.4037 11.25 16.068 11.25 15.6537V12.7405H8.33325C7.91904 12.7405 7.58325 12.4047 7.58325 11.9905C7.58325 11.5763 7.91904 11.2405 8.33325 11.2405H11.25V8.32739C11.25 7.91318 11.5858 7.57739 12 7.57739Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.31429 1.25C5.49524 1.25 3.96018 1.89884 2.88354 3.05377C1.81235 4.20285 1.25 5.79292 1.25 7.58516V16.4148C1.25 18.2062 1.80943 19.7964 2.87964 20.9459C3.9555 22.1015 5.49096 22.75 7.31429 22.75H16.6857C18.509 22.75 20.0445 22.1015 21.1204 20.9459C22.1906 19.7964 22.75 18.2062 22.75 16.4148V7.58516C22.75 5.79384 22.1906 4.20365 21.1204 3.05412C20.0445 1.89853 18.509 1.25 16.6857 1.25H7.31429ZM2.75 7.58516C2.75 6.10432 3.21146 4.90181 3.98074 4.07659C4.74458 3.25721 5.86666 2.75 7.31429 2.75H16.6857C18.1386 2.75 19.2603 3.25751 20.0225 4.07623C20.7904 4.90101 21.25 6.1034 21.25 7.58516V16.4148C21.25 17.8966 20.7904 19.099 20.0225 19.9238C19.2603 20.7425 18.1386 21.25 16.6857 21.25H7.31429C5.86142 21.25 4.73974 20.7425 3.9775 19.9238C3.20962 19.099 2.75 17.8966 2.75 16.4148V7.58516Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

PlusSquare.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          className="icon-secondary"
          d="M16.7741 2.19922H7.44076C4.03631 2.19922 2.10742 4.12811 2.10742 7.53255V16.8659C2.10742 20.2614 4.02742 22.1992 7.44076 22.1992H16.7741C20.1785 22.1992 22.1074 20.2614 22.1074 16.8659V7.53255C22.1074 4.12811 20.1785 2.19922 16.7741 2.19922Z"
        />
        <path
          className="icon-primary"
          d="M15.4279 12.9076H12.8569V15.4562C12.8569 15.8666 12.5214 16.1992 12.1074 16.1992C11.6935 16.1992 11.3579 15.8666 11.3579 15.4562V12.9076H8.78697C8.40084 12.8679 8.10742 12.5454 8.10742 12.1605C8.10742 11.7757 8.40084 11.4532 8.78697 11.4135H11.3498V8.87287C11.3898 8.4901 11.7152 8.19922 12.1034 8.19922C12.4916 8.19922 12.817 8.4901 12.8569 8.87287V11.4135H15.4279C15.814 11.4532 16.1074 11.7757 16.1074 12.1605C16.1074 12.5454 15.814 12.8679 15.4279 12.9076Z"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
